import React from 'react';
import ReactDOM from 'react-dom/client';
import { PersistGate } from 'redux-persist/integration/react';
import './config/api';
import './index.css';
import App from './App';
import store, { persistor } from './redux/store';
import { Provider } from 'react-redux';
import ThemeModeProvider from './theme/ThemeModeProvider';
import { PwaProvider } from './pwa/PwaProvider';
import QueryProvider from './providers/QueryProvider';
import { OfflineSyncProvider } from './providers/OfflineSyncProvider';
import { PushNotificationProvider } from './push/PushNotificationProvider';
import { FeatureProvider } from './context/FeatureContext';
import * as serviceWorkerRegistration from './pwa/serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ThemeModeProvider>
          <QueryProvider>
            <PwaProvider>
              <OfflineSyncProvider>
                <PushNotificationProvider>
                  <FeatureProvider>
                    <App />
                  </FeatureProvider>
                </PushNotificationProvider>
              </OfflineSyncProvider>
            </PwaProvider>
          </QueryProvider>
        </ThemeModeProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// Production only — keeps dev hot reload unaffected.
serviceWorkerRegistration.register();
